// extracted by mini-css-extract-plugin
export default {"eventos":"EventosContenedor_eventos__NVvrV","contBoton":"EventosContenedor_contBoton__Oy-eA","verMas":"EventosContenedor_verMas__RRqp5"};